import httpClient from "@/api/config";

const resetDefaultState = () => ({
	currentPage: 1,
	selectedSentiment: [],
	selectedTag:{
		values:[]
	},
	folder: undefined,
	selectedEmoji:[],
	selectedFacebookPages:[],
	commentSearchTerm:"",
});

export default {
	namespaced: true,

	state: {
		commentReady: true,
		monitorAllComments: {},
		sentimentPageReady: true,
		currentPage: 1,
		selectedSentiment: [],
		selectedTag:{
			values:[],
		},
		folder:undefined,
		monitorCommentsCount:undefined,
		selectedEmoji:[],
		selectedFacebookPages:[],
		commentSearchTerm:"",
	},

	actions: {
		fetchMonitorAllComments({commit}, {monitor_uuid, skip = 0, limit = 10, timerange, order = "desc", categories = [], tags = [], term = null, emojis=[], pages=[]}) {
			let data = {monitor_uuid, timerange, order, limit, skip, categories, tags, term, emojis, pages};
			return httpClient.post(`/elastic/monitor/comments/filter`,data)
				.then(({data: {comments, comments_count}}) => {
					commit("setMonitorAllComments", comments);
					commit("setMonitorCommentsCount", comments_count);
				});
		}
	},

	getters:{
		pagesAndCount(state, getters, rootState, rootGetters){
			return rootGetters.facebookPagesAndCount("fbcomments");
		}
	},

	mutations: {
		setMonitorAllComments(state, comments) {
			state.monitorAllComments = comments;
		},

		setMonitorCommentsCount(state, count){
			state.monitorCommentsCount = count;
		},

		setSentimentPageReady(state, status) {
			state.sentimentPageReady = status;
		},

		setCommentReady(state, status) {
			state.commentReady = status;
		},

		setCurrentPage(state, pageNo) {
			state.currentPage = pageNo;
		},

		setSelectedSentiment(state, sentiments) {
			state.selectedSentiment = sentiments
		},

		setSelectedTags(state, tags){
			state.selectedTag = tags
		},

		setSelectedFolder(state, folder){
			state.folder = folder
		},

		setDefaultSentimentState(state){
			Object.assign(state, resetDefaultState());
		},

		setSelectedEmoji(state, emoji){
			state.selectedEmoji = emoji;
		},

		setSelectedFacebookPages(state, page){
			state.selectedFacebookPages = page;
		},

		setCommentSearchTerm(state, term){
			state.commentSearchTerm = term;
		}
	}
};
